import Routes from '@service-requests/route-constants';
import * as React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

const RequestListRedirection = () => {
    const location = useLocation();
    const navigate = useNavigate();
    React.useEffect(() => {
        if (location.pathname.includes('/app/service-requests/open') || location.pathname.includes('/app/service-requests/close')) {
            navigate('/app' + Routes.unifiedTrackingPath());
        }

    }, [location.pathname]);

    return (
        <React.Fragment />
    )
}

export default RequestListRedirection;
